{
  "sheetHeader": {
    "itemProgress": "Item {current} of {total}",
    "pendingReview": "Pending review",
    "order": "Order"
  }
}
